import Link from 'next/link';
import type { FC } from 'react';
import { LINKS } from '@/Module/Core/Constant';
import { IconAngleLeft } from '@/Module/Icon';
import { MONTH_PERSIAN } from '@/Module/Subscription/Component/SubscriptionPageContainer/SubscriptionPageTabInner';
interface Props {
  title: string;
  duration: number | undefined;
}
const SubscriptionBuyTitle: FC<Props> = ({
  title,
  duration
}) => {
  return <>
      <div className="mb-4 flex flex-row p-4 text-lg  font-extrabold text-blueFive sm:mb-6 lg:mb-12">
        <h2 className=" flex-1 text-right text-lg  font-extrabold text-blueFive sm:pr-20   sm:text-center sm:text-2xl ">
          پیش فاکتور خرید اشتراک
        </h2>
        <Link href={LINKS.SUBSCRIPTION.MAIN} className=" group flex items-center text-sm font-bold text-blueFive sm:text-base" data-sentry-element="Link" data-sentry-source-file="SubscriptionBuyTitle.tsx">
          <span> تغییر اشتراک</span>
          <IconAngleLeft size="small" data-sentry-element="IconAngleLeft" data-sentry-source-file="SubscriptionBuyTitle.tsx" />
        </Link>
      </div>

      <div className=" mb-4 rounded-2xl bg-white p-4 shadow-[0px_4px_8px_-2px_rgba(0,0,0,0.10)] sm:px-6">
        <div className=" flex flex-row justify-between border-b-[1px] border-blackTwo py-4 font-semibold text-blueFive">
          <div className="w-[220px] font-bold text-blackSix sm:w-full">نوع اشتراک</div>
          <div className="w-full text-center text-base sm:text-lg">{title.split('_')[0]}</div>
        </div>
        <div className=" flex flex-row  justify-between py-4 font-semibold text-blueFive">
          <div className="w-[180px] font-bold text-blackSix sm:w-full">مدت اعتبار</div>
          <div className="w-full text-center text-base sm:text-lg">
            {duration ? ` اشتراک ${MONTH_PERSIAN[duration!]}` : <>
                یک ساله<span className="text-sm sm:text-base">(تا شروع سال تحصیلی جدید)</span>
              </>}
          </div>
        </div>
      </div>
    </>;
};
export default SubscriptionBuyTitle;